import { type CaregiverCostGroup } from '@/api/patient-monthly-metrics';

export type MergedCostGroup = { cost: number; totalShifts: number; totalCost: number };

// Backend groups by (price, cost); with price hidden in the UI, rows sharing a
// cost would look duplicated — merge them.
export function mergeCostGroups(groups: CaregiverCostGroup[]): MergedCostGroup[] {
  const byCost = new Map<number, MergedCostGroup>();
  groups.forEach((group) => {
    const row = byCost.get(group.cost) ?? { cost: group.cost, totalShifts: 0, totalCost: 0 };
    row.totalShifts += group.totalShifts;
    row.totalCost += group.totalCost;
    byCost.set(group.cost, row);
  });

  return [...byCost.values()];
}
